<h1>
    Contratistas invitados
    <span class="badge accent">{{ invitaciones?.length }}</span>
</h1>
<mat-divider></mat-divider>

<div fxLayout="row" fxLayoutAlign="space-around center">
    <mat-spinner
        *ngIf="cargandoInvitaciones"
        color="accent"
        diameter="50"
    ></mat-spinner>
</div>
<div *ngIf="invitaciones">
    <div
        *ngIf="invitaciones.length === 0 && !cargandoInvitaciones"
        class="mt-8 message-box error"
    >
        No se han encontrado invitaciones a cotizar
    </div>
    <table class="simple mt-8">
        <thead>
            <tr>
                <th>#</th>
                <th>Contratista</th>
                <th>Fecha plazo envio cotización</th>
                <!-- th>Estado</th -->
                <th></th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let invitacion of invitaciones; let idx = index">
                <td>
                    <strong>{{ idx + 1 }}.- </strong>
                </td>

                <td
                    class="primary-fg cursor-pointer"
                    (click)="verFichaContratista(invitacion.contratista.nrRut)"
                >
                    <div
                        fxLayout="row"
                        fxLayoutAlign="start start"
                        fxLayoutGap="14px"
                    >
                        <div>
                            <!-- img
                                class="avatar-imagen-mini"
                                [src]="getFoto(invitacion.contratista.codigoFoto)"
                                [alt]="
                                    invitacion.contratista.nombres +
                                    ' ' +
                                    invitacion.contratista.apellidos
                                "
                            / -->
                        </div>

                        <div>
                            <strong
                                >{{ invitacion.contratista.nombres }}
                                {{ invitacion.contratista.apellidos }}</strong
                            >
                            <br />
                            <small> {{ invitacion.contratista.rut }}</small>
                            <br />
                            <app-star-rating
                                [seteable]="false"
                                [evaluacion]="invitacion.contratista.evaluacion"
                            ></app-star-rating>
                        </div>
                    </div>
                </td>
                <td>
                    <span>{{
                        invitacion.fechaVigencia | date: "dd-MM-yyyy HH:mm"
                    }}</span>
                </td>
                <!-- td>
                    <strong
                        >{{ invitacion.estadoInvitacion.descripcion }}
                    </strong>
                    <br />
                </td -->
            </tr>
        </tbody>
    </table>
</div>
